import { render, staticRenderFns } from "./BookerStatsIcons.vue?vue&type=template&id=93059222"
import script from "./BookerStatsIcons.vue?vue&type=script&lang=js"
export * from "./BookerStatsIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports